{
  "book_now": {
    "en": "Book Now",
    "de": "Jetzt Buchen",
    "nl": "Boek Nu",
    "pt": "Reservar",
    "es": "Reservar",
    "it": "Prenotare",
    "fr": "Réserver Maintenant"
  }
}
